export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--4-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--4-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Report.vue?vue&type=style&index=0&id=68afd788&prod&lang=css&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Report.vue?vue&type=style&index=0&id=68afd788&prod&lang=css&scoped=true
// module id = 2402
// module chunks = 31